import React from "react";
import { Container } from "reactstrap";
import { Link as Link2 } from "react-router-dom";

import CTA from "../assets/images/bg/bg.jpg";
import VIDEO from "../assets/images/video/Numantra-Introduction.mp4";

export default function CTASection({ isVideoVisible }) {
  return (
    <section
      id="cta-section"
      className="section position-relative"
      style={{
        background: `url(${CTA}) center`,
        minHeight: "60vh",
        overflow: "hidden",
      }}
    >
      <div className="bg-overlay"></div>

      {/* Auto-playing Video Background */}
      {isVideoVisible && (
        <div
          className="position-absolute w-100 h-100 d-flex align-items-center justify-content-center"
          style={{ top: 0, left: 0, zIndex: 1 }}
        >
          <video
            autoPlay
            loop
            playsInline
            style={{
              objectFit: "contain",
              opacity: 0.8,
              maxWidth: "80%",
              maxHeight: "80%",
            }}
          >
            <source src={VIDEO} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      )}

      <Container
        className="d-flex align-items-center justify-content-center"
        style={{
          position: "relative",
          zIndex: 2,
          minHeight: "60vh",
        }}
      >
        {/* <div className="row justify-content-center w-100">
          <div className="col-lg-8 col-md-10">
            <div className="section-title text-center">
              <h4 className="title text-white mb-3">
                Ready to start your next web project now?
              </h4>
              <p className="text-white-50 mx-auto para-desc mb-0">
                Launch your campaign and benefit from our expertise on
                designing and managing conversion centered bootstrap v5 html
                page.
              </p>

              <div className="mt-4 pt-2">
                <Link2 to="#" className="btn btn-numantra-primary">
                  Get Started !
                </Link2>
              </div>
            </div>
          </div>
        </div> */}
      </Container>
    </section>
  );
}
